import { SmartSearchPanelBridge } from './SmartSearchPanelBridge';
import angular from 'angular';

angular
  .module('flowingly.runner.smart-search', [])
  .component('smartSearchPanel', SmartSearchPanelBridge);
